import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-cream" data-id="element-105">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-106">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-light/10 rounded-full blur-3xl" data-id="element-107" />
        <div className="absolute top-1/2 -left-24 w-64 h-64 bg-forest-light/10 rounded-full blur-3xl" data-id="element-108" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-109">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-110">
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-111">
            <FadeIn delay={0.1} data-id="element-112">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-forest/10 text-forest font-medium text-sm mb-6" data-id="element-113">
                <Star className="w-4 h-4 fill-emerald text-emerald" data-id="element-114" />
                <span data-id="element-115">Más de 10,000 latinos ya lo probaron</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-116">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-117">
                El Protocolo de los 10 Días:{' '}
                <span className="text-emerald" data-id="element-118">Desinflama tu Cuerpo</span> y
                Recupera tu Movilidad
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-119">
              <h2 className="text-xl md:text-2xl text-gray-600 mb-8 font-light leading-relaxed" data-id="element-120">
                Elimina la rigidez matutina y el cansancio crónico con el método
                de "Reseteo Mineral" diseñado para latinos en USA.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-121">
              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-122">
                <CTAButton data-id="element-123" />
              </div>
              <div className="mt-4 flex items-center justify-center lg:justify-start gap-2 text-sm text-gray-500" data-id="element-124">
                <ShieldCheck className="w-4 h-4 text-emerald" data-id="element-125" />
                <span data-id="element-126">Pago 100% seguro. Acceso inmediato.</span>
              </div>
            </FadeIn>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-127">
            <FadeIn delay={0.3} direction="left" data-id="element-128">
              <div className="relative" data-id="element-129">
                <div className="absolute inset-0 bg-gradient-to-tr from-forest/20 to-emerald/20 rounded-3xl transform rotate-3 scale-105" data-id="element-130" />
                <img src="https://cdn.magicpatterns.com/uploads/tvfPP16a5ZDh2hDR2n7LRZ/heylloyd-image-1775486841128.png" alt="Mujer latina leyendo el ebook Detox de Inflamación Celular en una tablet" className="relative z-10 rounded-3xl shadow-2xl w-full object-cover" data-id="element-131" />

                {/* Floating badge */}
                <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl z-20 flex items-center gap-4 animate-bounce" style={{
                animationDuration: '3s'
              }} data-id="element-132">
                  <div className="bg-emerald/10 p-3 rounded-full" data-id="element-133">
                    <Star className="w-6 h-6 text-emerald fill-emerald" data-id="element-134" />
                  </div>
                  <div data-id="element-135">
                    <p className="text-sm font-bold text-forest" data-id="element-136">
                      Resultados en
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-137">48-72 horas</p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}